import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { ReactComponent as BACKARROW } from "../../assets/images/arrow-left.svg";
import LOGO from "../../assets/images/UpdatedLogo.svg";

import LOGOWHITE from "../../assets/images/footer-logo.svg";
import { MainContext } from "../../utils/context";
import { apiCall, preloadImage } from "../../utils/helpers";
import RegisterForm from "./RegisterForm";
import OTPForm from "./OTPForm";
import AccountTypeSelect from "./AccountTypeSelect";
import AccountCategorySelect from "./AccountCategorySelect";
import GetAccessView from "./GetAccessView";
import Drawer from "../../components/drawer";
import InviteClaim from "./InviteClaim";
import WaitlistView from "./WaitlistView";
import AccountTypeDetails from "./AccountTypeDetails";
import ExpertDetails from "./ExpertDetails";

const ismobile = window.innerWidth <= 768;

export default function OnboardingDrawer({
  open = true,
  onClose = () => {},
  verifiedClientData = {},
  isInvitedByExpert = false,
}) {
  const { setMsg, setUser } = React.useContext(MainContext);
  const [typeIndex, setTypeIndex] = useState(0);
  const [data, setData] = useState({});
  const [verifying, setVerifying] = useState(false);
  const [selectedType, setSelectedType] = useState({ admin_type_id: 1 });
  const [categories, setCategories] = React.useState([]);
  const [selectedSubTypes, setSelectedSubTypes] = useState([]);
  const [showImage, setShowImage] = React.useState(false);
  const [stateList, setStateList] = React.useState([]);
  const [brandName, setBrandName] = React.useState("");
  const [centreName, setCentreName] = React.useState("");
  const [waitlistScreen, setWaitlistScreen] = React.useState(false);
  const [onBoardingData, setOnBoardingData] = React.useState([]);
  const [type, setType] = React.useState("");
  const [indexNum, setIndexNum] = useState(-1);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [isCustomer, setIsCustomer] = useState(false);
  console.log(isCustomer);

  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const expertId = params.get("expert_id");

  let questions =
    selectedType.admin_type_id === 1
      ? [
          "How do you train your clients?",
          "How do you collect payments?",
          "How many clients do you train?",
          "What would you prefer the most for your business?",
        ]
      : selectedType.admin_type_id === 2
      ? [
          "How do you sell your products?",
          "How do you market your brand?",
          "What would you prefer the most for your brand?",
        ]
      : [
          "How do you collect payments?",
          "How many members do you have?",
          "What would you prefer the most for your business?",
        ];

  React.useEffect(() => setTimeout(() => setShowImage(open), 600), [open]);

  React.useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const invite = params.get("invite");

    if (invite) getInviteDetails(invite);
  }, []);
  const userType = params.get("type");

  useEffect(() => {
    userType === "brand"
      ? setSelectedType((prev) => ({ ...prev, admin_type_id: 2 }))
      : userType === "centre"
      ? setSelectedType((prev) => ({ ...prev, admin_type_id: 3 }))
      : setSelectedType((prev) => ({ ...prev, admin_type_id: 1 }));
  }, []);
  React.useEffect(() => {
    setData(
      isInvitedByExpert
        ? {
            name: verifiedClientData?.customer_name,
            phone: verifiedClientData?.mobile,
            expert_id: verifiedClientData?.expert_id,
            otp: "",
          }
        : { name: "", phone: "", otp: "" }
    );
  }, [open]);

  const getInviteDetails = (inviteCode = "") => {
    setTypeIndex(-1);
    setVerifying(true);
    apiCall
      .post("v1/dopamine/receiveInvite", {
        shortcode: inviteCode,
        api_name: "receiveInvite",
        key: "JWT",
        secret: "DOPAMINE",
      })
      .then((res) => {
        setVerifying(false);
        if (res.status === 200 && res.data.success) {
          const data = res.data.data;
          setData({
            name: data.name,
            phone: data.mobile,
            invite_by: data.expert_name,
            invited_by: data.expert_id,
          });
        } else {
          setMsg(res.data.msg);
          navigate("/");
        }
      })
      .catch((err) => console.log(err));
  };

  const closeHandler = () => {
    if (typeIndex === 3) {
      setTypeIndex(2);
      setSelectedSubTypes([]);
    } else if (typeIndex === 4) {
      userType === "expert" ? setTypeIndex(0) : setTypeIndex(3);
      userType === "expert" && setData({ name: "", phone: "", otp: "" });

      setQuestionIndex(0);
      setIndexNum(-1);
      setSelectedSubTypes([]);
    } else if (selectedType.admin_type_id === 1 && typeIndex === 5) {
      setTypeIndex(0);
      setQuestionIndex(0);
      setIndexNum(-1);
      setSelectedSubTypes([]);
    } else if (selectedType.admin_type_id === 2 && typeIndex === 5) {
      setTypeIndex(3);
      setQuestionIndex(0);
      setIndexNum(-1);
      setSelectedSubTypes([]);
    } else if (typeIndex === 5) {
      setTypeIndex(4);
      setQuestionIndex(0);
      setIndexNum(-1);
      setSelectedSubTypes([]);
    } else if (isCustomer && typeIndex === 2) {
      setTypeIndex(0);
      setQuestionIndex(0);
      setIndexNum(-1);
      setOnBoardingData([]);
      setSelectedSubTypes([]);
      setData({ name: "", phone: "", otp: "" });
    } else {
      setShowImage(false);
      setQuestionIndex(0);
      setIndexNum(-1);
      onClose();
      setOnBoardingData([]);
      // setSelectedType({});

      setData({ name: "", phone: "", otp: "" });
      setSelectedSubTypes([]);
      // navigate("/");
      setVerifying(false);

      setTypeIndex(0);
    }
    // typeIndex !== 2 && setTypeIndex(typeIndex - 1);

    // setOnBoardingData([]);

    // setData({ name: "", phone: "", otp: "" });
    // setSelectedSubTypes([]);
    // // navigate("/");
    // setVerifying(false);
  };

  const sendOtphandler = (next = true) => {
    setVerifying(true);
    let payload = { mobile: data.phone, name: data.name, login_type: "mobile" };
    if (data.invited_by) payload = { ...payload, invited_by: data.invited_by };
    apiCall
      .post("v1/user/sendOtp", payload)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setMsg("Otp sent successfully");
          if (next) setTypeIndex(typeIndex + 1);
        } else setMsg(res.data.msg);
        setVerifying(false);
      })
      .catch((err) => console.log(err));
  };

  const verifyOtpHandler = () => {
    setVerifying(true);
    let payload = { otp: data.otp, mobile: data.phone, login_type: "mobile" };
    if (data.invited_by) payload = { ...payload, invited_by: data.invited_by };
    apiCall
      .post("v1/user/verifyOtp", payload)
      .then((res) => {
        console.log("res", res);

        if (res.status === 200 && res.data.success) {
          const userObj = res.data.data || {};

          if (!userObj.user_id) return setMsg(res.data.msg);
          setData({ ...data, ...userObj, expert_id: expertId });
          setMsg(
            userObj.is_newuser
              ? "Registered successfully"
              : "Logged in successfully"
          );
          userType === "expert"
            ? userObj.is_newuser
              ? setTypeIndex(3)
              : setTypeIndex(5)
            : setTypeIndex(
                userObj.is_customer === 1 && expertId
                  ? typeIndex + 1
                  : userObj.role_id !== 2
                  ? typeIndex + 1
                  : typeIndex + 4
              );

          userType === "expert" &&
            accountTypeSubmitHandler("", "", userObj.user_id);

          userType === "expert" && getCategories(selectedType.admin_type_id);
          setType("training_mode");

          if (userType === "expert") {
            selectedType?.admin_type_id === 1
              ? getExpertOnboardingData({ user_type: "expert" })
              : selectedType?.admin_type_id === 2
              ? getExpertOnboardingData({
                  user_type: "brand",
                })
              : getExpertOnboardingData({ user_type: "centre" });
          }

          setUser(userObj);
          if (userObj.admin_type_id) getCategories(userObj.admin_type_id);
          // }
        } else setMsg(res.data.msg);
        setVerifying(false);
      })
      .catch((err) => console.log(err));
  };

  const accountTypeSubmitHandler = (brandName, centreName, user_id) => {
    setBrandName(brandName);
    setCentreName(centreName);
    setVerifying(true);

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const source = params.get("source");
    const medium = params.get("medium");
    const user = params.get("user");
    const payload =
      source && medium && user
        ? {
            user_id: user_id || data.user_id,
            name: data.name,
            admin_type_id: selectedType.admin_type_id,
            brand_name: brandName,
            centre_name: centreName,
            source: source,
            medium: medium,
            invited_by: user,
            role_id: 2,
            key: "JWT",
            secret: "DOPAMINE",
            api_name: "createAdminType",
          }
        : {
            user_id: user_id || data.user_id,
            name: data.name,
            admin_type_id: selectedType.admin_type_id,
            brand_name: brandName,
            centre_name: centreName,
            role_id: 2,
            key: "JWT",
            secret: "DOPAMINE",
            api_name: "createAdminType",
          };

    apiCall
      .post("v1/user/createAdminType", payload)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          if (userType !== "expert") {
            data?.is_newuser === 1 && setTypeIndex(typeIndex + 1);
            getCategories(selectedType.admin_type_id);
          }
        } else setMsg(res.data.msg);
        setVerifying(false);
      })
      .catch((err) => setVerifying(false));
  };

  const getCategories = (admin_type_id = 1) => {
    apiCall
      .post("v1/user/getCategoryList", {
        admin_type_id,
        key: "JWT",
        secret: "DOPAMINE",
        api_name: "getCategoryList",
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          res.data.data.forEach((category) => {
            preloadImage(category.inactive_icon);
            preloadImage(category.active_icon);
            return category;
          });
          setCategories(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  };

  const subTypeSubmitHandler = (otherExpertise) => {
    setVerifying(true);
    apiCall
      .post("v1/user/addCategory", {
        user_id: data.user_id,
        category_ids: selectedSubTypes.map((st) => st.category_id),
        other: otherExpertise,
        key: "JWT",
        secret: "DOPAMINE",
        api_name: "addCategory",
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setTypeIndex(typeIndex + 1);
          setType("training_mode");
          selectedType?.admin_type_id === 1
            ? getExpertOnboardingData({ user_type: "expert" })
            : selectedType?.admin_type_id === 2
            ? getExpertOnboardingData({
                user_type: "brand",
              })
            : getExpertOnboardingData({ user_type: "centre" });
        } else setMsg(res.data.msg);
        setVerifying(false);
      })
      .catch((err) => setVerifying(false));
  };

  const updateProfile = (user_type, question_id, selectedData, other) => {
    // setVerifying(true);
    let payload = {
      user_id: data.user_id,
      option_id: selectedData,
      question_id,
      user_type,
      other,
      api_name: "postUserOnboardingResponse",
    };
    apiCall
      .post("v2/user/postUserOnboardingResponse", payload)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          if (onBoardingData.length - 1 === questionIndex) {
            userType === "expert"
              ? setTypeIndex(5)
              : setTypeIndex(typeIndex + 1);
            setIndexNum(-1);
            setMsg("Details captured successfully");
          }
          setVerifying(false);
        } else setMsg(res.data.msg);
      })
      .catch((err) => setVerifying(false));
  };

  const createAddressSubmitHandler = (address) => {
    setVerifying(true);
    apiCall
      .post("v1/user/createAddress", {
        key: "JWT",
        secret: "DOPAMINE",
        api_name: "createAddress",
        user_id: data.user_id,
        address1: address.address1,
        address2: address.address2,
        landmark: address.landmark,
        city: address.city,
        state: address.state,
        pincode: address.pincode,
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) setTypeIndex(typeIndex + 1);
        else setMsg(res.data.msg);
        setVerifying(false);
      })
      .catch((err) => setVerifying(false));
  };

  const getStates = () => {
    apiCall
      .post("v1/user/getStateList", {
        api_name: "getStateList",
        key: "JWT",
        secret: "DOPAMINE",
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) setStateList(res.data.data);
        else setMsg(res.data.msg);
      })
      .catch((err) => setVerifying(false));
  };

  const getExpertOnboardingData = (payload) => {
    apiCall
      .post("v2/user/getUserOnboardingData", {
        ...payload,
        api_name: "getUserOnboardingData",
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setIndexNum((prev) => prev + 1);
          selectedType.admin_type_id === 1
            ? indexNum === -1
              ? setType("members_count")
              : // setType("training_mode")
              indexNum === 0
              ? setType("training_mode")
              : // setType("payment_mode")
              indexNum === 1
              ? setType("charge")
              : indexNum === 2
              ? setType("payment_mode")
              : indexNum === 3
              ? setType("collab")
              : indexNum === 4
              ? setType("preference")
              : setType("")
            : selectedType.admin_type_id === 2
            ? indexNum === -1
              ? setType("production_mode")
              : indexNum === 0
              ? setType("marketing_mode")
              : indexNum === 1
              ? setType("preference")
              : setType("")
            : indexNum === -1
            ? setType("payment_mode")
            : indexNum === 0
            ? setType("members_count")
            : indexNum === 1
            ? setType("get_members")
            : indexNum === 2
            ? setType("interaction")
            : indexNum === 3
            ? setType("preference")
            : setType("");

          setOnBoardingData(res.data.data);
        } else setMsg(res.data.msg);
      })
      .catch((err) => setVerifying(false));
  };

  const contentType =
    selectedType?.admin_type_id === 1 || selectedType?.admin_type_id === 2
      ? [
          <RegisterForm
            data={data}
            setData={setData}
            verifying={verifying}
            registerHandler={sendOtphandler}
          />,
          <OTPForm
            data={data}
            setData={setData}
            verifying={verifying}
            resendOtpHandler={sendOtphandler}
            otpSubmitHandler={verifyOtpHandler}
          />,
          <AccountTypeSelect
            userType={userType}
            data={data}
            isInvitedByExpert={isInvitedByExpert}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            verifying={verifying}
            typeIndex={typeIndex}
            setTypeIndex={setTypeIndex}
            accountTypeSubmitHandler={accountTypeSubmitHandler}
            getStates={getStates}
            stateList={stateList}
            setIsCustomer={setIsCustomer}
          />,
          <AccountCategorySelect
            // userType={userType}
            categories={categories}
            selectedType={selectedType}
            selectedSubTypes={selectedSubTypes}
            verifying={verifying}
            setSelectedSubTypes={setSelectedSubTypes}
            categorySubmitHandler={subTypeSubmitHandler}
          />,

          <ExpertDetails
            selectedType={selectedType}
            index={questionIndex}
            setIndex={setQuestionIndex}
            data={onBoardingData}
            setOnBoardingData={setOnBoardingData}
            verifying={verifying}
            updateProfile={updateProfile}
            typeIndex={typeIndex}
            setTypeIndex={setTypeIndex}
            type={type}
            indexNum={indexNum}
            setIndexNum={setIndexNum}
            questions={questions}
          />,
          <GetAccessView
            data={data}
            categories={categories}
            selectedType={selectedType}
            selectedSubTypes={selectedSubTypes}
            verifying={verifying}
            // getAccessHandler={() => data.is_invited === 0 ? setTypeIndex(typeIndex + 1) : setMsg("App access requested successfully !")}
            getAccessHandler={() => setTypeIndex(typeIndex + 1)}
            brandName={brandName}
            centreName={centreName}
          />,
          <WaitlistView data={data} setWaitlistScreen={setWaitlistScreen} />,
        ]
      : [
          <RegisterForm
            data={data}
            setData={setData}
            verifying={verifying}
            registerHandler={sendOtphandler}
          />,
          <OTPForm
            data={data}
            setData={setData}
            verifying={verifying}
            resendOtpHandler={sendOtphandler}
            otpSubmitHandler={verifyOtpHandler}
          />,
          <AccountTypeSelect
            userType={userType}
            data={data}
            isInvitedByExpert={isInvitedByExpert}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            verifying={verifying}
            typeIndex={typeIndex}
            setTypeIndex={setTypeIndex}
            accountTypeSubmitHandler={accountTypeSubmitHandler}
            setIsCustomer={setIsCustomer}
          />,
          <AccountTypeDetails
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            verifying={verifying}
            createAddressSubmitHandler={createAddressSubmitHandler}
            stateList={stateList}
          />,
          <AccountCategorySelect
            categories={categories}
            selectedSubTypes={selectedSubTypes}
            verifying={verifying}
            setSelectedSubTypes={setSelectedSubTypes}
            categorySubmitHandler={subTypeSubmitHandler}
          />,

          <ExpertDetails
            selectedType={selectedType}
            index={questionIndex}
            setIndex={setQuestionIndex}
            data={onBoardingData}
            setOnBoardingData={setOnBoardingData}
            verifying={verifying}
            updateProfile={updateProfile}
            typeIndex={typeIndex}
            setTypeIndex={setTypeIndex}
            type={type}
            indexNum={indexNum}
            setIndexNum={setIndexNum}
            questions={questions}
          />,
          <GetAccessView
            data={data}
            categories={categories}
            selectedType={selectedType}
            selectedSubTypes={selectedSubTypes}
            verifying={verifying}
            // getAccessHandler={() => data.is_invited === 0 ? setTypeIndex(typeIndex + 1) : setMsg("App access requested successfully !")}
            getAccessHandler={() => setTypeIndex(typeIndex + 1)}
            brandName={brandName}
            centreName={centreName}
          />,
          <WaitlistView data={data} setWaitlistScreen={setWaitlistScreen} />,
        ];

  return (
    <Drawer
      showImage={showImage}
      setShowImage={setShowImage}
      open={open}
      closeHandler={closeHandler}
    >
      <div
        style={{
          // backgroundColor:
          //   (typeIndex === 5 && waitlistScreen) ||
          //   (typeIndex === 6 && waitlistScreen)
          //     ? "#FF4A01"
          //     : typeIndex === 0
          //     ? "#121212"
          //     : "#fff",
          backgroundColor: "#121212",
        }}
        className="drawer-header"
      >
        {typeIndex >= 0 && (
          <div
            style={{
              position: "absolute",
              width: ismobile ? "90vw" : "48vh",
            }}
          >
            {/* <IconButton
              onClick={() =>
                typeIndex !== 0 && (typeIndex !== 4) && typeIndex !== 5
                  ? setTypeIndex(typeIndex - 1)
                  : closeHandler()
              }
              className="drawer-back-btn"
            >
              <BACK />
            </IconButton> */}
            {/* {(typeIndex === 0 ||
              typeIndex === 1 ||
              (selectedType.admin_type_id !== 3 && typeIndex === 4) ||
              typeIndex === 5 ||
              (selectedType.admin_type_id === 3 && typeIndex === 6)) && (
              <IconButton
                onClick={() => closeHandler()}
                className="drawer-back-btn"
              >
                <BACKARROW />
              </IconButton>
            )} */}
            {
              <IconButton
                onClick={() => closeHandler()}
                className="drawer-back-btn"
              >
                <BACKARROW />
              </IconButton>
            }
          </div>
        )}
        <div className="drawer-logo">
          {(typeIndex === 8 && waitlistScreen) ||
          (typeIndex === 7 && waitlistScreen) ? (
            <img height="100%" width="100%" alt="" src={LOGOWHITE} />
          ) : (
            <img height="100%" width="100%" alt="" src={LOGO} />
          )}
          {/* <img height="100%" width="100%" alt="" src={LOGO} /> */}
        </div>
      </div>
      {typeIndex >= 0 ? (
        <div
          className={
            typeIndex === contentType.length - 1
              ? "request-wrapper-waitlist"
              : "request-wrapper"
          }
          style={{
            // backgroundColor: typeIndex === 0 ? "#121212" : ""
            backgroundColor: "#121212",
          }}
        >
          {contentType[typeIndex] || <div>No Content</div>}
        </div>
      ) : (
        <InviteClaim
          data={data}
          verifying={verifying}
          inviteClaimHandler={() => {
            sendOtphandler(false);
            setTypeIndex(1);
          }}
        />
      )}
    </Drawer>
  );
}
